var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReply = function SvgReply(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.926 7.567c.322 0 .584.261.584.583v2.012l3.298-3.514L8.51 3.133V4.51a.583.583 0 0 1-.545.582l-.305.02c-2.954.2-5.024 2.522-5.486 5.35C3.992 8.243 5.911 7.566 7.6 7.566h.327Zm-1.237.999c-1.386.247-2.961 1.126-4.49 3.395-.317.472-1.028.344-1.032-.226-.03-3.743 2.462-7.271 6.432-7.538V2.364c0-.554.67-.824 1.048-.421l4.02 4.283a.617.617 0 0 1 0 .843l-4.02 4.284c-.378.402-1.048.132-1.048-.422V8.486a5.17 5.17 0 0 0-.91.08Z"
  })));
};
export default SvgReply;